"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_PUNCH_DATA_TEST_IDS = void 0;
var EDIT_PUNCH_DATA_TEST_IDS;
(function (EDIT_PUNCH_DATA_TEST_IDS) {
    EDIT_PUNCH_DATA_TEST_IDS["ADD_PUNCH"] = "PWFADDPunch";
    EDIT_PUNCH_DATA_TEST_IDS["EDIT_PUNCH"] = "PWFEditPunch";
    EDIT_PUNCH_DATA_TEST_IDS["PUNCH_DETAILS"] = "PWFEditPunchPunchDetails";
    EDIT_PUNCH_DATA_TEST_IDS["PUNCH_INPUTS"] = "PWFEditPunchPunchInputs";
    EDIT_PUNCH_DATA_TEST_IDS["PUNCH_INPUTS_ERROR"] = "PWFEditPunchPunchInputsError";
    EDIT_PUNCH_DATA_TEST_IDS["PUNCH_TIME_INPUT"] = "PWFEditPunchTimeInputs";
    EDIT_PUNCH_DATA_TEST_IDS["PUNCH_DATE_PICKER"] = "PWFEditPunchDatePicker";
    EDIT_PUNCH_DATA_TEST_IDS["MILITARY_TIME_CHECKBOX"] = "PWFEditPunchMilitaryTimeCheckbox";
    EDIT_PUNCH_DATA_TEST_IDS["LOCKED_OUT_WARNING_BANNER"] = "PWFEditPunchLockOutWarningBanner";
})(EDIT_PUNCH_DATA_TEST_IDS = exports.EDIT_PUNCH_DATA_TEST_IDS || (exports.EDIT_PUNCH_DATA_TEST_IDS = {}));
